import { ClientsClient, GetClient } from 'src/app/generated-client/generated-client';

import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { MultiSelectClientComponent } from '../multi-select-client/multi-select-client.component';
import { MatButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
    selector: 'da-add-client-dialog',
    templateUrl: './add-client-dialog.component.html',
    styleUrl: './add-client-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MultiSelectClientComponent, MatButton, MatDialogClose]
})
export class AddClientDialogComponent implements OnInit {
  private clientsClient = inject(ClientsClient);

  addingClients = signal<GetClient[]>([]);
  unassignedClients = signal<GetClient[]>([]);

  ngOnInit(): void {
    this.clientsClient.getClients(null, null).subscribe({
      next: (list: GetClient[]) => {
        this.unassignedClients.set(list.filter(item => !item.customerId));
      },
      error: err => console.error(err)
    });
  }

  selectClients(event: GetClient[]): void {
    this.addingClients.set(event);
  }
}
